import React, { useContext } from 'react';
import { LayerContext } from './layer-context';
import {LayerPortal} from './layer-portal';

export function LayersPortaled(): JSX.Element {
  const { layers } = useContext(LayerContext);
  return (
    <>
      {layers?.map((layer) => (
        <LayerPortal layerResult={layer} key={layer.id} />
      ))}
    </>
  );
}
